export function inputErrorsToValidationErrors(inputErrors: any) {
  return inputErrors.reduce((errors: any, { field, message }: any) => {
    return { ...errors, [field]: message };
  }, {});
}
